/* eslint-disable no-undef */
(function (window) {
    "use strict";

    function defineApiResponseHandlerHelper() {
        var apiResponseHandlerHelepr = {};
        apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus = function (httpStatusCode, supportCode) {
            var origin = window.location.origin;

            if (httpStatusCode === 302 || httpStatusCode === 401 || httpStatusCode === 403) {
                var origin = window.location.origin;
                var hasAlreadyShownError = false;
                console.log("hasAlreadyShownError", hasAlreadyShownError);
                if (hasAlreadyShownError) {
                    return;
                }

                $("#sessionExpiredModal").on("hidden.bs.modal", function () {
                    window.location.replace(origin + "/Account/Login");
                });

                $("#sessionExpiredModal").modal("show");
                return false;
            }
            
            if (httpStatusCode >= 500) {
                // show exception error with support code
                alert("Unexpected error occurred. Please contact support with reference code: " + supportCode);
                return false;
            }
            
            return true;
        };

        apiResponseHandlerHelepr.displaySessionExpiredMessage = function (httpStatus) {
            if (httpStatus === 302 || httpStatus === 401 || httpStatus === 403) {
                var origin = window.location.origin;
                var hasAlreadyShownError = false;
                console.log("hasAlreadyShownError", hasAlreadyShownError);
                if (hasAlreadyShownError) {
                    return;
                }

                $("#sessionExpiredModal").on("hidden.bs.modal", function () {
                    window.location.replace(origin + "/Account/Login");
                });

                $("#sessionExpiredModal").modal("show");

                hasAlreadyShownError = true;
            } else {
                //alert("Unexpected error occurred");
                document.getElementById("globalErrorModalErrorMessageDiv").innerHTML = "Unexpected error occurred";
                $("#globalErrorModal").modal("show");
            }
        };
        return apiResponseHandlerHelepr;
    }

    //define globally if it doesn't already exist
    if (typeof (apiResponseHandlerHelepr) === "undefined") {
        window.apiResponseHandlerHelepr = defineApiResponseHandlerHelper();
    } else {
        console.log("apiResponseHandlerHelepr already defined.");
    }
})(window);